import {SECURITY_SECTION_ITEMS} from '@/shared/constants/landingPagesConstants';
import {Box, Card, CardContent, Grid, Stack, Typography} from '@mui/material';

const SectionWrapper = ({title, children}) => (
  <Box mb={5}>
    <Typography fontWeight={700} fontSize={22} mb={2}>
      {title}
    </Typography>
    {children}
  </Box>
);

const LangText = ({en, nl}) => (
  <Stack spacing={0.5}>
    <Typography fontSize={14}>
      <strong>EN:</strong> {en}
    </Typography>
    <Typography fontSize={14} color='text.secondary'>
      <strong>NL:</strong> {nl}
    </Typography>
  </Stack>
);

const FeatureCard = ({item}) => (
  <Card
    variant='outlined'
    sx={{
      height: '100%',
      borderRadius: 3,
      p: 2,
      transition: 'all 0.3s ease',
      '&:hover': {
        boxShadow: 3,
        transform: 'translateY(-4px)',
      },
    }}
  >
    <Stack spacing={2}>
      <Box
        component='img'
        src={item.image}
        alt={item.title.en}
        sx={{
          width: 40,
          height: 40,
        }}
      />

      <LangText en={item.title.en} nl={item.title.nl} />

      <Typography fontSize={14} color='text.secondary'>
        {item.description.en}
      </Typography>
    </Stack>
  </Card>
);

export const StaticSecuritySection = () => {
  const {label, includings, extras} = SECURITY_SECTION_ITEMS;

  return (
    <Box>
      {/* Label */}
      <SectionWrapper title='Label'>
        <LangText en={label.en} nl={label.nl} />
      </SectionWrapper>

      {/* Includings */}
      <SectionWrapper title='Included as standard'>
        <Stack spacing={2} mb={3}>
          <LangText en={includings.title.en} nl={includings.title.nl} />
          <Typography fontSize={15} color='text.secondary' maxWidth={800}>
            {includings.description.en}
          </Typography>
        </Stack>

        <Grid container spacing={3}>
          {includings.list.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <FeatureCard item={item} />
            </Grid>
          ))}
        </Grid>
      </SectionWrapper>

      {/* Extras */}
      <SectionWrapper title='Extras'>
        <Stack spacing={2} mb={3}>
          <LangText en={extras.title.en} nl={extras.title.nl} />
          <Typography fontSize={15} color='text.secondary' maxWidth={800}>
            {extras.description.en}
          </Typography>
        </Stack>

        <Grid container spacing={3}>
          {extras.list.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <FeatureCard item={item} />
            </Grid>
          ))}
        </Grid>
      </SectionWrapper>
    </Box>
  );
};
